import angular from 'angular';
import sectionTitleComponent from './sectionTitle.component';

let sectionTitleModule = angular.module('sectionTitle', [])

  .component('sectionTitle', sectionTitleComponent)

  .name;

export default sectionTitleModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/sectionTitle/sectionTitle.js